/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIContractAutocompleteSuggestion } from './APIContractAutocompleteSuggestion';
import {
    APIContractAutocompleteSuggestionFromJSON,
    APIContractAutocompleteSuggestionFromJSONTyped,
    APIContractAutocompleteSuggestionToJSON,
} from './APIContractAutocompleteSuggestion';

/**
 * 
 * @export
 * @interface APIContractAutocompleteResponse
 */
export interface APIContractAutocompleteResponse {
    /**
     * 
     * @type {Array<APIContractAutocompleteSuggestion>}
     * @memberof APIContractAutocompleteResponse
     */
    suggestions: Array<APIContractAutocompleteSuggestion>;
    /**
     * 
     * @type {number}
     * @memberof APIContractAutocompleteResponse
     */
    total: number;
}

/**
 * Check if a given object implements the APIContractAutocompleteResponse interface.
 */
export function instanceOfAPIContractAutocompleteResponse(value: object): value is APIContractAutocompleteResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function APIContractAutocompleteResponseFromJSON(json: any): APIContractAutocompleteResponse {
    return APIContractAutocompleteResponseFromJSONTyped(json, false);
}

export function APIContractAutocompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContractAutocompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(APIContractAutocompleteSuggestionFromJSON)),
        'total': json['total'],
    };
}

export function APIContractAutocompleteResponseToJSON(value?: APIContractAutocompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map(APIContractAutocompleteSuggestionToJSON)),
        'total': value['total'],
    };
}

